import React from 'react';
import StyledFilterButton from './FilterButton.style';

function FilterButton({ onClick, active, children}) {
  return (
    <StyledFilterButton>
      {/* eslint-disable-next-line max-len */}
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
      <div className={active ? 'filter-button active' : 'filter-button'} onClick={onClick}>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a>{children}</a>
      </div>
    </StyledFilterButton>
  );
}

export default FilterButton;
